import { el, setAttr } from 'redom';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import './index.scss';

class FontSizeInput {

  constructor(configuration) {

    this.size = configuration.size || 12;
    this.min = configuration.min || 8;
    this.max = configuration.max || 100;
    this.step = configuration.step || .5;
    this.onChange = configuration.onChange;

    this.label = el('label', 'px');
    this.slider = el('input', {
      ...this.buildAttributes(),
      type: 'range',
      oninput: this.handleSliderChange.bind(this)
    });
    this.input = el('input', {
      ...this.buildAttributes(),
      type: 'number',
      oninput: this.handleInputChange.bind(this)
    });

    this.el = el('.editor-font-size-input', [
      this.slider,
      this.input,
      this.label
    ]);

  }

  onmount() {

    const anchor = this.el.closest('[class*="button-section"]');

    if (anchor === null) {
      return;
    }

    displayElementAroundAnchor(this.el, anchor, document.body, 5, 5, 'bottom', true);

  }

  buildAttributes() {

    return {
      value: this.size || 12,
      min: 8,
      max: 100,
      step: .5,
    };

  }

  handleSliderChange(event) {

    this.size = event.target.value;
    this.input.value = this.size;
    this.onChange(this.size);

  }

  handleInputChange(event) {

    this.size = event.target.value;
    this.slider.value = this.size;
    this.onChange(this.size);

  }

  update(configuration) {

    this.size = configuration.size || 12;
    this.min = configuration.min || 8;
    this.max = configuration.max || 100;
    this.step = configuration.step || .5;
    this.onChange = configuration.onChange;

    setAttr(this.slider, this.buildAttributes());
    setAttr(this.input, this.buildAttributes());

  }

}

export default FontSizeInput;